// @ts-ignore
import { on } from 'common/js/utils/dom';

on('click', '[data-js-scroll-to-element]', (event, target) => {
    const href = target.getAttribute('href');

    if (!href) {
        return;
    }

    const elementId = href.substring(1);

    if (!elementId) {
        return;
    }

    const element = document.getElementById(elementId);

    if (element) {
        event.preventDefault();
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });
    }
});
